module.exports = __webpack_public_path__ + "images/locator/icon-list-view-a4a62b6d.svg";